import { FC } from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from 'react-router-dom';
import { CustomNavigate, GlobalModals } from '@app/page-components';
import { AppLayout } from './app/layout';
import { HomeLayout } from './home/layout';

export const RootLayout: FC = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/app/*' element={<AppLayout />} />
          <Route path='/home/*' element={<HomeLayout />} />
          {/* Route anything else back to default. */}
          <Route path='/*' element={<CustomNavigate to='/home' />} />
        </Routes>
      </BrowserRouter>
      <GlobalModals />
    </>
  );
};
